// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/components/install/useInstallApp.ts
// 🔧 PURPOSE: Lo stato di "Installa l'app" per React (lib/installApp):
//   già installata? che passi mostrare? Si aggiorna quando Chrome manda la
//   sua finestra, quando l'app viene installata e quando l'ospite sceglie.
// ============================================

import { useEffect, useState } from 'react';
import {
  canPromptInstall,
  detectInstalledApp,
  INSTALL_CHANGED_EVENT,
  installGuide,
  installPrefs,
  isStandalone,
  markedInstalled,
  type InstallGuide,
} from '../../lib/installApp';

export interface InstallAppState {
  /** Aperta come app, installata da qui, trovata da Chrome o "L'ho già installata". */
  installed: boolean;
  guide: InstallGuide;
}

export function useInstallApp(): InstallAppState {
  const [, setTick] = useState(0);
  const [related, setRelated] = useState(false);

  useEffect(() => {
    const refresh = () => setTick((n) => n + 1);
    window.addEventListener(INSTALL_CHANGED_EVENT, refresh);
    window.addEventListener('storage', refresh);
    let alive = true;
    detectInstalledApp().then((yes) => {
      if (alive && yes) setRelated(true);
    });
    return () => {
      alive = false;
      window.removeEventListener(INSTALL_CHANGED_EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  return {
    installed: isStandalone() || markedInstalled() || related || installPrefs().never,
    guide: installGuide(undefined, undefined, canPromptInstall()),
  };
}
